var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isActiveOrder } from '@yandex-taxi/js-integration-api';
import { useEffect, useRef, useState } from 'react';
import { useAPIContext } from '../../../../components/Context';
import { createAsyncState } from '../hooks';
import { useAuthorizationState } from '../authorization/hooks';
export var useOrdersAsync = createAsyncState('orders');
export var useOrdersQuery = function () {
    var _a, _b;
    var isAuthorized = ((_a = useAuthorizationState().data) === null || _a === void 0 ? void 0 : _a.authorization_status) === 'authorized';
    var search = useAPIContext().search;
    var _c = useOrdersAsync(), asyncState = _c[0], baseActions = _c[1];
    var _d = useState(baseActions), actions = _d[0], setActions = _d[1];
    var isStarted = useRef(false);
    var orders = (_b = asyncState.data) === null || _b === void 0 ? void 0 : _b.orders;
    // запрос в search
    useEffect(function () {
        if (search && isAuthorized) {
            actions.start();
            return search({
                onSuccess: actions.success,
                onError: actions.error,
            });
        }
    }, [actions, search]);
    // поллинг организован через создание нового объекта actions
    // таким образом срабатывает эффект запроса, потому что изменился депс actions
    useEffect(function () {
        if (orders && orders.length > 0) {
            var active = orders.some(isActiveOrder);
            // если активного заказа нет, то считаем что поллинг закончился
            if (!active) {
                isStarted.current = false;
                return;
            }
            // если поллинг не начался, нет смысла ждать несколько секунд, лучше начать сразу
            if (!isStarted.current) {
                isStarted.current = true;
                setActions(__assign({}, baseActions));
                return;
            }
            var timer_1 = setTimeout(function () { return setActions(__assign({}, baseActions)); }, 2000);
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [baseActions, orders]);
    return asyncState;
};
export var useOrdersState = function () { return useOrdersAsync()[0]; };
